import { DOMAINS } from './domains'; 

export const API_ENDPOINTS = {
    TICKETS_BY_PROJECT_KEY: '/api/tickets/by-project-key/',
    TICKETS_BY_ASSIGNEE: '/api/tickets/by-assignee/',
    TICKETS_BY_STATUS: '/api/tickets/by-week-status/',
    TICKETS_TSA:'/api/tickets/by-cat-tsa/',
    TICKETS_NON_TSA:'/api/tickets/by-cat-non-tsa/',

    // SerialNumber endpoints
    SMARTSHIPPER_SERIAL_NUMBERS: `${DOMAINS.backend}smartshipper/serial_numbers/`,
    SMARTSHIPPER_SERIAL_NUMBER_DETAIL: (id) => 
      `${DOMAINS.backend}smartshipper/serial_numbers/${id}/`,
    SMARTSHIPPER_LOGS: `${DOMAINS.backend}smartshipper/serial_number_logs/`,

    // Software Licenses
    SOFTWARE_LICENSES: `${DOMAINS.backend}licenses/`,
    SOFTWARE_LICENSE_DETAIL: (id) => `${DOMAINS.backend}licenses/${id}/`,
    LICENSES_BULK_UPLOAD: `${DOMAINS.backend}licenses/bulk-upload/`,

    // SFTP
    SFTP_LIST_FILES: `${DOMAINS.backend}sftp/list-files/`,
    SFTP_UPLOAD_FILE: `${DOMAINS.backend}sftp/upload/`,
    SFTP_DOWNLOAD_FILE: (remotePath) =>
      `${DOMAINS.backend}sftp/download/?remote_path=${encodeURIComponent(remotePath)}`,

    // Azure Storage Manager
    AZURE_STORAGE_LIST: `${DOMAINS.backend}azure-storage/list/`,
    AZURE_STORAGE_SAS: `${DOMAINS.backend}azure-storage/sas/`,
    AZURE_STORAGE_UPLOAD: `${DOMAINS.backend}azure-storage/upload/`,

    // SUA / Payments
    PAYMENTS_SUA_GENERATE: `${DOMAINS.backend}payments/sua/generate/`,
    PAYMENT_RECORDS: `${DOMAINS.backend}payments/records/`,
    PAYMENT_RECORD_DETAIL: (id) => `${DOMAINS.backend}payments/records/${id}/`,
    
};